module.exports = __webpack_public_path__ + "static/media/bank.6c92d08a.png";